<template>
  <div class="directions-renderer">
    <!-- Ce composant agit comme un contrôleur, pas de rendu enfant -->
  </div>
</template>

<script>
export default {
  name: 'DirectionsRenderer',
  props: {
    // map: { type: Object, required: true }, // Reçoit la carte directement
    // origin: { type: [Object, String], required: true },
    // destination: { type: [Object, String], required: true },
    // waypoints: { type: Array, default: () => [] },
    // travelMode: { type: String, default: 'WALKING' },
    // suppressMarkers: { type: Boolean, default: true },
    // options: { type: Object, default: () => ({}) },
    map: { type: Object, required: true },
    origin: { type: [Object, String], required: true },
    destination: { type: [Object, String], required: true },
    waypoints: { type: Array, default: () => [] },
    travelMode: { type: String, default: 'WALKING' },
  },
  data() {
    return { ds: null, dr: null, gmaps: null }
  },
  mounted() {
    console.log("🚀 DirectionsRenderer est monté dans le DOM !");
    this.init()
  },
  beforeUnmount() {
    if (this.dr) { this.dr.setMap(null); this.dr = null }
    this.ds = null
  },
  watch: {
    origin() { this.route() },
    destination() { this.route() },
    map() { this.init() }
  },
  methods: {
    init() {
      this.gmaps = window.google?.maps || null;
      if (!this.gmaps) {
        setTimeout(this.init, 100);
        return;
      }

      if (!this.map) {
        console.log("⚠️ DirectionsRenderer : Toujours pas d'objet map reçu");
        return;
      }

      this.ds = new this.gmaps.DirectionsService();
      this.dr = new this.gmaps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
        preserveViewport: true
      });
      console.log("🛠️ Directions Service & Renderer initialisés");
      this.route();
    },
    route() {
      if (!this.ds || !this.dr || !this.origin || !this.destination) {
        return;
      }

      // 1. On "nettoie" les coordonnées pour Google (conversion Proxy -> Simple Object)
      const cleanOrigin = {
        lat: parseFloat(this.origin.lat),
        lng: parseFloat(this.origin.lng)
      };
      const cleanDestination = {
        lat: parseFloat(this.destination.lat),
        lng: parseFloat(this.destination.lng)
      };

      // 2. On formate les waypoints correctement
      // Google attend : { location: {lat: x, lng: y}, stopover: true }
      let formattedWaypoints = [];
      if (Array.isArray(this.waypoints)) {
        formattedWaypoints = this.waypoints
          .filter(wp => wp && (wp.lat || (wp.location && wp.location.lat))) // On garde que ce qui est valide
          .map(wp => {
            const loc = wp.location || wp;
            return {
              location: { lat: parseFloat(loc.lat), lng: parseFloat(loc.lng) },
              stopover: true
            };
          });
      }

      console.log("📡 Envoi requête propre :", { origin: cleanOrigin, dest: cleanDestination, wps: formattedWaypoints });

      this.ds.route(
        {
          origin: cleanOrigin,
          destination: cleanDestination,
          waypoints: formattedWaypoints,
          travelMode: this.travelMode || 'WALKING'
        },
        (res, status) => {
          if (status === 'OK') {
            console.log("✅ ITINÉRAIRE REÇU ET AFFICHÉ !");
            this.dr.setDirections(res);
          } else {
            console.error("❌ Erreur Google API Status : " + status);
          }
        }
      );
    }
  }
}
</script>

<style scoped>
.directions-renderer {
  display: contents;
}
</style>



<!-- <template></template>

<script>
export default {
  name: 'DirectionsRenderer',
  props: {
    origin: { type: [Object, String], required: true },
    destination: { type: [Object, String], required: true },
    waypoints: { type: Array, default: () => [] },
    travelMode: { type: String, default: 'WALKING' },
    suppressMarkers: { type: Boolean, default: true },
    options: { type: Object, default: () => ({}) },
  },
  data() {
    return { ds: null, dr: null, gmaps: null, map: null }
  },
  mounted() { this.init() },
  beforeUnmount() {
    if (this.dr) { this.dr.setMap(null); this.dr = null }
    this.ds = null
  },
  watch: {
    origin: 'route',
    destination: 'route',
    waypoints: { handler: 'route', deep: true },
    travelMode: 'route',
    options: { handler(n) { if (this.dr && n) this.dr.setOptions(n) }, deep: true },
    suppressMarkers(n) { if (this.dr) this.dr.setOptions({ suppressMarkers: n }) },
  },
  methods: {
    init() {
      this.gmaps = window.google?.maps || null
      if (!this.gmaps) return void setTimeout(this.init, 50)
      this.map = this.$parent?.$map || this.$parent?.map || this.$parent?.$?.ctx?.$map || null
      if (!this.map) return void setTimeout(this.init, 50)
      this.ds = new this.gmaps.DirectionsService()
      this.dr = new this.gmaps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: this.suppressMarkers,
        ...this.options,
      })
      this.route()
    },
    route() {
      if (!this.ds || !this.dr || !this.origin || !this.destination) return
      const g = this.gmaps
      const travelMode = g.TravelMode?.[this.travelMode] || g.TravelMode?.WALKING || 'WALKING'
      const waypoints = (this.waypoints || []).map(wp => (wp && (wp.location || typeof wp === 'string')) ? wp : { location: wp })
      this.ds.route(
        { origin: this.origin, destination: this.destination, waypoints, travelMode, optimizeWaypoints: false, provideRouteAlternatives: false },
        (res, status) => {
          if (status === 'OK') this.dr.setDirections(res)
        }
      )
    },
  }
}
</script> -->
